import { gql } from '@apollo/client';
import { WebUserContact, WebUser } from 'types/User';
import { WEB_USER_CONTACT_FRAGMENT, WEB_USER_FRAGMENT } from './WebUserFragments';

export const GET_ME_QUERY = gql`
  query GetMe {
    me {
      user {
        ...webUserFields
      }
    }
  }
  ${WEB_USER_FRAGMENT}
`;

export type GetMeOutput = {
  me: {
    user: WebUser;
  };
};

export const GET_CONTACTS_BY_CHANNEL_QUERY = gql`
  query GetContactsByChannel($channel: String!) {
    webUsers(channel: $channel) {
      errorReason
      webUsers {
        ...WebUserContact
        __typename
      }
      __typename
    }
  }
  ${WEB_USER_CONTACT_FRAGMENT}
`;

export enum WebUserError {
  UNAUTHORIZED,
}

export type GetContactsByChannelOutput = {
  webUsers: {
    errorReason: WebUserError;
    webUsers: WebUserContact[];
  };
};
